<template lang="pug">
  form
    .form
      .form__elem
        .form-elem.form-elem_horizontal
          .form-elem__title Старый логин
          .form-elem__main
            input.input(
            type="email"
            )
      .form__elem
        .form-elem.form-elem_horizontal
          .form-elem__title Новый логин
          .form-elem__main
            input.input(
            type="email"
            )
      .form__elem.form__elem_align-right
        .form-elem
          .form-elem__main
            button.button.button_paint-main Изменить логин
</template>

<script>
export default {
  name: "form-login",
};
</script>
